// hooks/useReportData.js
import { useState, useEffect } from "react";
import httpclient from "../../../Utils";

const useReportData = (url, appliedFilters, buildQueryString) => {
  const [reportData, setReportData] = useState({
    by_state: [],
    by_store: [],
    by_company: [],
    msg: "",
    start_date: "",
    end_date: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [title, setTitle] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const fetchData = async () => {
    setLoading(true);
    try {
      const queryString = buildQueryString(appliedFilters);
      const { data } = await httpclient.get(`${url}${queryString}`);

      // Update state with the new API structure
      setReportData({
        by_state: data?.by_state || [],
        by_store: data?.by_store || [],
        by_company: data?.by_company || [],
        msg: data?.msg || "",
        start_date: data?.start_date || "",
        end_date: data?.end_date || "",
      });

      setTitle(data?.msg || "");
      setStartDate(data?.start_date || "");
      setEndDate(data?.end_date || "");
      setError(null);
    } catch (err) {
      setError(err);
      console.error("Error fetching report data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [appliedFilters]);

  return {
    reportData,
    title,
    loading,
    error,
    startDate,
    endDate,
    refetch: fetchData,
  };
};

export default useReportData;
